export default __webpack_public_path__ + "static/media/classes.12f2fae1.svg";